import React from 'react';

import { Box, Typography, useTheme, useMediaQuery } from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';

import { monochrome } from '../../theme/styles';
import { PaginationButton } from './components/PaginationButton';
import { buttonTypes, CustomPaginationProps } from './types';
import { useStyles } from './styles';

export const CustomPagination = ({
  page,
  pageCount,
  pageSize,
  rowCount,
  setPage,
}: CustomPaginationProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const extraSmallMobile = useMediaQuery(theme.breakpoints.only('xs'));

  const getToResult = (): number => {
    const maxSize = pageSize * (page + 1);
    return maxSize > rowCount ? rowCount : maxSize;
  };

  return (
    <Box className={classes.wrapper}>
      {!!rowCount && (
        <Box className={classes.infoWrapper}>
          <Typography
            variant="caption"
            style={{ color: theme.palette.type === 'dark' ? monochrome.medium : monochrome.dark }}>
            {pageSize * page + 1} - {getToResult()} of {rowCount}
          </Typography>
        </Box>
      )}

      {!!rowCount && (
        <Box display="flex" gridGap={extraSmallMobile ? 8 : 16} alignItems="center">
          <PaginationButton
            width={77}
            type={buttonTypes.PREVIOUS}
            disabled={!page}
            extraSmallMobile={extraSmallMobile}
            setPage={() => setPage(page - 1)}
          />
          <Pagination
            color="primary"
            siblingCount={0}
            hideNextButton
            hidePrevButton
            classes={{
              root: classes.paginationRoot,
            }}
            count={pageCount}
            page={page + 1}
            onChange={(event, value) => setPage(value - 1)}
          />
          <PaginationButton
            width={77}
            type={buttonTypes.NEXT}
            disabled={page + 1 === pageCount}
            extraSmallMobile={extraSmallMobile}
            setPage={() => setPage(page + 1)}
          />
        </Box>
      )}
    </Box>
  );
};
